import { atRoundEnd, defineGameCard, heatsUp } from '../authoring/index.js';
export const ThermalInverterCard = defineGameCard({
    id: 'thermal_inverter',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 3, health: 5 }, keywords: ['RUSH'] },
    presentation: {
        name: 'Термальный инвертор',
        description: 'Натиск. Греется. В конце раунда меняет местами свою атаку и здоровье.',
        glyph: {
            colors: ['#98746D', '#8C6373', '#9941C5'],
            rows: [
                '3212.232.',
                '3..21131.',
                '.11223333',
                '2232132..',
                '.131211.1',
                '2.33.3...',
                '12..33212',
                '23.122123',
                '322112.21',
            ],
        },
    },
    role: 'playable',
    abilities: [
        heatsUp(),
        atRoundEnd((ctx) => {
            const self = ctx.self;
            if (self === undefined)
                return;
            const { attack, health, maxHealth } = ctx.q.stats(self);
            if (attack > maxHealth)
                ctx.ops.modifyStat(self.id, 'maxHealth', attack - maxHealth);
            ctx.ops.modifyStat(self.id, 'attack', health - attack);
            ctx.ops.modifyStat(self.id, 'health', attack - health);
        }),
    ],
    ui: { mechanics: ['rush', 'heats_up', 'heat'] },
});
//# sourceMappingURL=thermal_inverter.js.map